import type { CheckoutPurchase } from '../types';

export type TransactionType = 'free_trial' | 'buy_now' | 'product_change';

export const getTransactionType = (
    purchase: CheckoutPurchase,
    isSubscriptionChange?: boolean,
): TransactionType => {
    if ('withTrial' in purchase && purchase.withTrial) {
        return 'free_trial';
    }
    if (isSubscriptionChange) {
        return 'product_change';
    }

    return 'buy_now';
};
